module.exports = __webpack_public_path__ + "img/select1.ad881184.svg";